export default [
  {
    path: "/admin",
    name: "admin",
    component: () => import("@/CommonDP/adminPages/index"),
    meta: {
      routeName: "系统",
      icon: require("@/CommonDP/assets/settings/system.svg")
    },
    children: [
      // 企业管理
      {
        path: "/adminResources",
        name: "adminResources",
        component: () => import("@/CommonDP/adminPages/settings/resources"),
        meta: {
          routeName: "权限资源",
          prouteName: "权限资源",
          ppname: "系统",
          icon1: require("@/CommonDP/assets/settings/permission.svg"),
          icon2: require("@/CommonDP/assets/settings/permission.svg")
        }
      },
      {
        path: "/applicationSettings",
        name: "applicationSettings",
        component: () => import("@/CommonDP/pages/mainMg/settings/applicationSettings/index.vue"),
        meta: {
          prouteName: "应用管理",
          routeName: "权限资源",
          ppname: "系统",
          icon1: require("@/CommonDP/assets/settings/applicationSettings.svg"),
          icon2: require("@/CommonDP/assets/settings/applicationSettings.svg")
        }
      },
      {
        path: "/adminPermisson",
        name: "adminPermisson",
        component: () => import("@/CommonDP/adminPages/settings/rolePowerConfig"),
        meta: {
          routeName: "资源分配",
          prouteName: "资源分配",
          ppname: "系统",
          icon1: require("@/CommonDP/assets/settings/resourceAssign.svg"),
          icon2: require("@/CommonDP/assets/settings/resourceAssign.svg")
        }
      },
      {
        path: "/adminMaintenance",
        name: "adminMaintenance",
        component: () => import("@/CommonDP/adminPages/settings/maintenance"),
        meta: {
          routeName: "数据字典",
          prouteName: "数据字典",
          ppname: "系统",
          icon1: require("@/CommonDP/assets/settings/maintenance.svg"),
          icon2: require("@/CommonDP/assets/settings/maintenance.svg")
        }
      },
      // {
      //   path: "/adminPoints",
      //   name: 'adminPoints',
      //   component: () => import('@/CommonDP/adminPages/settings/planApprovalPoints'),
      //   meta: {
      //     routeName: '审图要点',
      //     prouteName: "审图要点",
      //     ppname: "系统",
      //     // icon1: require("@/CommonDP/assets/settings/drawPoints1.png"),
      //     icon2: require("@/CommonDP/assets/settings/drawPoints2.png")
      //   }
      // },
      {
        path: "/adminDownPlug",
        name: "adminDownPlug",
        component: () => import("@/CommonDP/adminPages/settings/downPlug"),
        meta: {
          routeName: "插件端程序",
          prouteName: "插件端程序",
          ppname: "系统",
          icon1: require("@/CommonDP/assets/settings/downPlug.svg"),
          icon2: require("@/CommonDP/assets/settings/downPlug.svg")
        }
      },
      {
        path: "/adminDownApp",
        name: "adminDownApp",
        component: () => import("@/CommonDP/adminPages/settings/downApp"),
        meta: {
          routeName: "APP安装包",
          prouteName: "APP安装包",
          ppname: "系统",
          icon1: require("@/CommonDP/assets/settings/adminDownApp.svg"),
          icon2: require("@/CommonDP/assets/settings/adminDownApp.svg")
        }
      },
      {
        path: "/adminManualHelp",
        name: "adminManualHelp",
        component: () => import("@/CommonDP/adminPages/settings/manualHelp"),
        meta: {
          routeName: "帮助手册",
          prouteName: "帮助手册",
          ppname: "系统",
          icon1: require("@/CommonDP/assets/settings/manualHelp.svg"),
          icon2: require("@/CommonDP/assets/settings/manualHelp.svg")
        }
      },

      {
        path: "/folderTemplate",
        name: "folderTemplate",
        component: () => import("@/CommonDP/adminPages/folderTemplate/index"),
        meta: {
          routeName: "目录模板",
          prouteName: "目录模板",
          ppname: "系统",
          icon1: require("@/CommonDP/assets/settings/folderTemplate.svg"),
          icon2: require("@/CommonDP/assets/settings/folderTemplate.svg")
        }
      }
    ]
  }
];
